



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TransactionTotal extends Vue {


    public unsubscribe = this.$store.subscribeAction((action, state) => {
        // if (action.type === 'toggleLegend') {
        //     this.initLegend();
        // }
    });

    get transactionTotal() {
        return this.$store.state.heatmap.transactionTotal;
    }

    // public toggleShow() {
    //     this.$store.dispatch('toggleLegend');
    // }

    public mounted() {
        console.log('TransactionTotal: mounted()');
    }

    public beforeDestroy() {
        console.log('TransactionTotal: beforeDestroy()');
        this.unsubscribe();
    }

}

